import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { setMentionUser, setUsersList } from 'store/entities/users/actions'
import { getUsersList } from 'store/entities/users/selectors'
import MentionTextArea from './MentionTextArea'
import { getIdentityUserData } from 'store/entities/identity/selectors'

const mapDispatchToProps = {
  onRequest: setUsersList,
  setMentionUser,
}

const mapStateToProps = createStructuredSelector({
  users: getUsersList,
  identity: getIdentityUserData,
})

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(MentionTextArea))
